import { render, staticRenderFns } from "./header-welcome.vue?vue&type=template&id=395d6963&scoped=true&"
import script from "./header-welcome.vue?vue&type=script&lang=js&"
export * from "./header-welcome.vue?vue&type=script&lang=js&"
import style0 from "./header-welcome.vue?vue&type=style&index=0&id=395d6963&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d6963",
  null
  
)

export default component.exports